import { SysProductResponse } from 'src/modules/user/models/sysProductResponse';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'SysProduct';

export const getAllSysProducts = () => {
  return AxiosInstance.get<PagedResult<SysProductResponse>>(`${controller}`, {
    params: {
      pageIndex: 0,
      pageSize: 500,
      sortCol: 'product_id',
      sortDir: 'desc',
    },
  });
};
